@if (visible()) {
  <neo-alert
    class="ccf-notification__element"
    animate.enter="ccf-notification__element--enter"
    animate.leave="ccf-notification__element--leave"
    [attr.brand]="brand()"
    [type]="alertType()"
    [fullWidth]="false"
    [fullWidthInFlow]="layout() === 'inline'"
    [visible]="visible()"
    [variant]="dismissible() ? 'dismissible' : ''"
    [attr.role]="role()"
    [attr.aria-live]="ariaLive()"
    [attr.expanded]="expanded() ? '' : null"
    (neo-alert-toggle)="onToggle($event)">
    <span slot="headline">{{ message() }}</span>
    <ng-content />
  </neo-alert>
}
